import { useToast } from '@repo/design-system/index'
import produce from 'immer'
import { useRouter } from 'next/router'
import { ITutor } from '../../../model/tutor.interface'
import apis from '../../../modules/apis'
import { axiosPost } from '../../../modules/axiosHelper'
import { n_favorite_tutors } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { TUTOR_TYPE } from '../../vars'

export const useOnclickHeartTutor = ({ isList, tutorItems, setTutorItems }) => {
  // isList : is among list of tutors
  const { t } = useTranslation()
  const router = useRouter()
  const { toastInfo } = useToast()

  const getAsPath = (type) => {
    if (type == TUTOR_TYPE.SEARCH_TUTOR_RESULT) {
      return 'portal/tutor/search'
    } else if (type == 'search_3') {
      return 'lesson/schedule/add/all'
    } else if (type == 'search_4') {
      return 'lesson/schedule/add/favorite'
    } else if (type == 'tab-result') {
      return 'lesson/schedule/add/search'
    } else if (router.asPath.includes('portal/home')) {
      return 'portal/home'
    } else if (router.asPath.includes('portal/lessons/upcoming-lessons')) {
      return 'lesson/upcoming'
    } else if (router.asPath.includes('portal/lessons/review')) {
      return 'lesson/past'
    } else if (router.asPath.includes('portal/tutors/recommended/rookie-tutors')) {
      return 'portal/tutor/rookie-tutors'
    } else if (router.asPath.includes('portal/tutors/recommended')) {
      return 'portal/tutor/featured'
    } else if (router.asPath.includes('portal/tutors/my-tutors')) {
      if (type == 'experience') {
        return 'portal/tutor/prev'
      } else {
        return 'portal/tutor/favorite'
      }
    } else if (router.asPath.includes('portal/tutors')) {
      return 'portal/tutor/all'
    } else {
      return 'etc'
    }
  }

  return async (e: React.MouseEvent, tutor: ITutor, type: null | string = null, showToast = true) => {
    e.preventDefault()
    e.stopPropagation()

    let isMyTutor = false
    if (tutor?.is_mine == undefined) {
      isMyTutor = tutor.is_my_tutor
    } else {
      isMyTutor = tutor.is_mine
    }
    try {
      const responseData = await axiosPost(isMyTutor ? apis.tutor.delete() : apis.tutor.add(), {
        tutor_id: tutor.id,
        referrer: getAsPath(type),
      })
      if (!responseData.success) {
        console.error(responseData)
        return
      }
      if (showToast)
        toastInfo(
          isMyTutor ? t(n_favorite_tutors.delete_tutor.toast_succeed) : t(n_favorite_tutors.add_tutor.toast_succeed)
        )
    } catch (error) {
      console.error(error)
      return
    }

    // if list of tutors
    if (isList) {
      let cloneTutorItems = tutorItems
      cloneTutorItems = produce(tutorItems, (draft) => {
        const targetItem = draft.find((item) => item.id == tutor.id)
        targetItem.is_mine = !targetItem.is_mine
      })
      setTutorItems(cloneTutorItems)
    }
  }
}
